import React from 'react';
import PropTypes from 'prop-types';
import {isNil} from 'ramda';
import {Icon, Header} from 'semantic-ui-react';
import styled from 'styled-components';
import {CharcoalContainer} from '../Container/ContainerMix';

const PrecessedIcon = styled(Icon.Group)`
  margin: calc(30vh - 50px) auto 20px auto;
  color: #ffffff;
`;

const StyledContainer = styled(CharcoalContainer)`
    height: 100vh;
`;

const Spinner = ({text}) => (
  <StyledContainer>
    <PrecessedIcon size="huge">
      <Icon loading size="big" name="spinner" />
    </PrecessedIcon>
    {!isNil(text) ? (
      <Header as="h3" icon textAlign="center" style={{color: '#ffffff', marginTop: 'calc(100hv - 100px)'}}>
        <Header.Content>{text}</Header.Content>
      </Header>
) : null}
  </StyledContainer>
);

Spinner.propTypes = {
  text: PropTypes.string
};

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/Spinner/Spinner.js